import { Routes } from '@angular/router';
import { AuthGuard } from '../guards/auth.guard';

export const basRoutes: Routes = [
  {
    path: 'job',
    loadChildren: () =>
      import('../pages/bas/job/job.module').then(
        (module) => module.JobModule
      ),
    canActivate: [AuthGuard],
  },
  {
    path: "cadastro-generico",
    loadChildren: () =>
      import("../pages/cad/cadastro-generico/cadastro-generico.module").then(
        (module) => module.CadastroGenericoModule
      ),
    canActivate: [AuthGuard],
  },
  {
    path: "relacao-generica",
    loadChildren: () =>
      import("../pages/bas/relacao-generica/relacao-generica.module").then(
        (module) => module.RelacaoGenericaModule
      ),
    canActivate: [AuthGuard],
  },
  {
    path: 'usuario',
    loadChildren: () =>
      import('../pages/bas/usuario/usuario.module').then(
        (module) => module.UsuarioModule
      ),
    canActivate: [AuthGuard],
  },
  {
    path: 'cadastro-generico',
    loadChildren: () =>
      import(
        '../pages/cad/cadastro-generico/cadastro-generico.module'
      ).then((module) => module.CadastroGenericoModule),
    canActivate: [AuthGuard],
  },
  {
    path: 'programa',
    loadChildren: () =>
      import('../pages/bas/programa/programa.module').then(
        (module) => module.ProgramaModule
      ),
    canActivate: [AuthGuard],
  },
  {
    path: "auditoria",
    loadChildren: () =>
      import("../pages/bas/auditoria/auditoria.module").then(
        (module) => module.AuditoriaModule
      ),
    canActivate: [AuthGuard],
  },
  {
    path: 'consulta-log-acesso',
    loadChildren: () => import('../pages/bas/consulta-log-acesso/consulta-log-acesso.module').then(
      (module) => module.ConsultaLogAcessoModule
    ),
    canActivate: [AuthGuard],
  },
  {
    path: "parametro-generico",
    loadChildren: () =>
      import("../pages/bas/parametros-genericos/parametros-genericos.module").then(
        (module) => module.ParametrosGenericosModule
      ),
    canActivate: [AuthGuard],
  },
  {
    path: "modulo",
    loadChildren: () =>
      import("../pages/bas/modulo/modulo.module").then(
        (module) => module.ModuloModule
      ),
    canActivate: [AuthGuard],
  },
  {
    path: 'saldo',
    loadChildren: () =>
      import('../pages/bas/saldo/saldo.module').then(
        (module) => module.SaldoModule
      ),
    canActivate: [AuthGuard],
  },
  {
    path: 'saldo',
    loadChildren: () =>
      import('../pages/bas/saldo/saldo.module').then(
        (module) => module.SaldoModule
      ),
    canActivate: [AuthGuard],
  },
  {
    path: 'monitor-fila-email',
    loadChildren: () =>
      import('../pages/bas/monitor-fila-email/monitor-fila-email.module').then(
        (module) => module.MonitorFilaEmailModule
      ),
    canActivate: [AuthGuard],
  },
];
